module.exports = __webpack_public_path__ + "img/TechArchCompositeBow_ua.8c4fe1fd.webp";